/**
 * Vue 组件异常采集
 */
import type { App, ComponentPublicInstance } from 'vue';
import { MONITOR_CONFIG } from '@/monitor/config';
import { readApiContext, reportUncaughtApiError } from '@/monitor/collectors/apiError';
import { track } from '@/monitor/core/aggregator';

/** 从组件实例上取组件名，用于定位是哪个组件炸的 */
const componentName = (instance: ComponentPublicInstance | null): string => {
  const type = instance?.$?.type as { name?: string; __name?: string } | undefined;
  return type?.name ?? type?.__name ?? '未知组件';
};

export const setupVueErrorCollector = (app: App): void => {
  app.config.errorHandler = (
    err: unknown,
    instance: ComponentPublicInstance | null,
    info: string,
  ) => {
    const error = err instanceof Error ? err : new Error(String(err));
    /**
     * 接口错误没人 catch、一路冒到组件层时，报成「Vue 组件异常」会误导：
     * 堆栈里全是 axios 内部帧，真正有用的接口路径和参数反而看不到。
     * 改按「后端接口报错」上报，带出路径、状态码和参数。
     */
    const apiContext = readApiContext(err);
    if (apiContext) {
      reportUncaughtApiError(apiContext, error.message, {
        组件: componentName(instance),
        钩子: info,
      });
    } else {
      track({
        type: 'vue_error',
        level: 'error',
        title: 'Vue 组件异常',
        message: error.message,
        stack: error.stack?.split('\n').slice(0, MONITOR_CONFIG.STACK_LINES).join('\n'),
        extra: { 组件: componentName(instance), 钩子: info },
        timestamp: Date.now(),
      });
    }
    /** 接了监控不代表控制台就不用报错，开发时仍要能直接看到原始错误 */
    console.error(err);
  };
};
